import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Box, Typography, CircularProgress, Chip } from "@material-ui/core";
import { getVendorWithUserAnswersForAdmin } from "src/api/vendorServices";
import { DisplayUserAnswers } from "src/components/commons/DisplayUserAnswers";
import { FounderProfileDisplay } from "src/components/commons/FounderProfileDisplay";
import { Main } from "src/components/commons/Main";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";

const statusMap = { IN_PROGRESS: "In Progress", ACTIVE: "Active", INACTIVE: "Inactive" };

export function VendorApplicationDetails() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setError(null);
                setLoading(true);
                const response = await getVendorWithUserAnswersForAdmin(id);
                setData(response);
            } catch (err) {
                console.error("Unable to fetch vendor service details", err);
                setError("Unable to load vendor service details");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box p={4}>
                <Typography color="error">{error}</Typography>
            </Box>
        );
    }

    if (!data) {
        return (
            <Box p={4}>
                <Typography>No data found</Typography>
            </Box>
        );
    }

    return (
        <>
            <Breadcrumbs separator="›" aria-label="breadcrumb" style={{ marginBottom: 16 }}>
                <Link to="/applications/vendor">
                    <Typography color="textSecondary">All Vendor Services</Typography>
                </Link>
                <Typography color="textPrimary">Detail</Typography>
            </Breadcrumbs>
            <Main>
                <Box
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent="space-between"
                    p={4}
                    borderBottom={"1px solid rgb(239 232 251)"}
                >
                    <Typography component={"h2"} variant="h6">
                        Detail
                    </Typography>
                </Box>
                <Box p={4}>
                    <Typography component={"h3"} variant="h5">
                        {data.name}
                    </Typography>
                    <h3 className="text-lg py-2 px-4 bg-slate-200 mt-4">Vendor Profile</h3>
                    <FounderProfileDisplay
                        userDetails={{ ...data.creator, details: data.creator.profile }}
                    />
                    <DisplayUserAnswers
                        id={`vendor-${data.id}`}
                        isAdmin={true}
                        type="vendor"
                        answers={data.userAnswers}
                    />
                </Box>
            </Main>
        </>
    );
} 